/**
 * Admin Plans API
 * ადმინისტრატორის გეგმების API
 */

import { get, post, put, del } from '@aiia/portal-core';

export interface AdminPlanFeature {
  featureCode: string;
  displayName: string;
  limitValue: number;
  unlimited: boolean;
  isBooleanFeature: boolean;
}

export interface PlanAdminResponse {
  code: string;
  name: string;
  description: string | null;
  monthlyPrice: number;
  yearlyPrice: number;
  currency: string;
  active: boolean;
  publicPlan: boolean;
  sortOrder: number;
  features: AdminPlanFeature[];
  subscriptionCount: number;
}

export interface CreatePlanRequest {
  code: string;
  name: string;
  description?: string;
  monthlyPrice?: number;
  yearlyPrice?: number;
  active?: boolean;
  publicPlan?: boolean;
}

export interface UpdatePlanRequest {
  name?: string;
  description?: string;
  monthlyPrice?: number;
  yearlyPrice?: number;
  active?: boolean;
  publicPlan?: boolean;
  sortOrder?: number;
}

export interface AdminPlanFeatureRequest {
  featureCode: string;
  limitValue?: number;
  unlimited?: boolean;
}

export interface UpdateAdminPlanFeaturesRequest {
  features: AdminPlanFeatureRequest[];
}

// Get all plans
export const getAdminPlans = () =>
  get<PlanAdminResponse[]>('/admin/plans');

// Get plan by code
export const getAdminPlan = (code: string) =>
  get<PlanAdminResponse>(`/admin/plans/${code}`);

// Create new plan
export const createPlan = (data: CreatePlanRequest) =>
  post<PlanAdminResponse>('/admin/plans', data);

// Update plan
export const updatePlan = (code: string, data: UpdatePlanRequest) =>
  put<PlanAdminResponse>(`/admin/plans/${code}`, data);

// Delete plan
export const deletePlan = (code: string) =>
  del<void>(`/admin/plans/${code}`);

// Update plan features
export const updateAdminPlanFeatures = (code: string, data: UpdateAdminPlanFeaturesRequest) =>
  put<void>(`/admin/plans/${code}/features`, data);
